export default "__VITE_ASSET__27ec32fa__"